import { __rest } from "tslib";
import React, { useRef, useState } from 'react';
import LxPopover from '@web-common/components/UI/LxPopover/LxPopover';
import Loadable from '@loadable/component';
const EmojiPicker = Loadable(() => import('@web-common/components/UI/EmojiPicker'));
const HOCEditorEmoji = (Component) => {
    const EditorEmoji = (props) => {
        const { ref } = props, rest = __rest(props, ["ref"]);
        const getEmojiResultCBRef = useRef((emoji) => { });
        const [emojiPos, setEmojiPos] = useState({
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
        });
        const [emojiVisible, setEmojiVisible] = useState(false);
        const insertEmojiAction = (emojiIconPosition, callback) => {
            setEmojiPos({
                top: emojiIconPosition.top,
                left: emojiIconPosition.left,
                bottom: emojiIconPosition.bottom,
                right: emojiIconPosition.right,
            });
            getEmojiResultCBRef.current = callback;
            setEmojiVisible(true);
        };
        const onEmojiSelect = (val) => {
            getEmojiResultCBRef.current(val.native);
            setEmojiVisible(false);
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(Component, Object.assign({}, rest, { ref: ref, insertEmojiAction: insertEmojiAction })),
            React.createElement(LxPopover, { top: emojiPos.top, left: emojiPos.left, right: emojiPos.right, bottom: emojiPos.bottom, visible: emojiVisible, setVisible: setEmojiVisible, height: 264, acceptTopBottom: true }, emojiVisible ? React.createElement(EmojiPicker, { onEmojiSelect: onEmojiSelect, visible: emojiVisible }) : undefined)));
    };
    return React.forwardRef((props, ref) => React.createElement(EditorEmoji, Object.assign({}, props, { ref: ref })));
};
export default HOCEditorEmoji;
